import { BadgeConfigurationRequest, BadgeConfigurationRequestFromBadgeConfiguration } from "./BadgeConfigurationRequest";
import { IdentityRole } from "../model/Event";

export interface LocationRequest {
    name: string;
}

export interface PositionRequest {
    name: string;
}

export interface AccreditationLevelRequest {
    name: string;
    badgeText: string;
}

export interface IdentityRoleRequest {
    internalName: string;
    badgeName: string;
    defaultAccreditationLevelId: number|null;
    schedulable: boolean;
    hasAppAccess: boolean;

    badgeOverridden: boolean;
    badgeConfiguration?: BadgeConfigurationRequest;
}

export interface EventRequest {
    clientId: number;

    name: string;

    startDate: Date;
    endDate: Date;
}

export interface DuplicateEventRequest {
    name: string;
    startDate: number; // epoch millis
    endDate: number;   // epoch millis
    copyProvisioningsForRoleIds?: number[];
}

export const IdentityRoleRequestFromIdentityRole = (role: IdentityRole): IdentityRoleRequest => {
    return {
        internalName: role.internalName,
        badgeName: role.badgeName,
        defaultAccreditationLevelId: role.defaultAccreditationLevel ? role.defaultAccreditationLevel.id : null,
        schedulable: role.schedulable,
        hasAppAccess: role.hasAppAccess,

        badgeOverridden: role.badgeOverridden,
        badgeConfiguration: BadgeConfigurationRequestFromBadgeConfiguration(role.badgeConfiguration)
    };
};
